import actionTypes from '../action-types'
import { toast } from 'react-toastify'
import axios from 'axios'
import { setUrlParams } from '../../utils/functions'
import { generatePath } from 'react-router-dom'
import selectors from '../selectors'
import actions from './index'
import { lang } from '../../utils/withLang'
import {
  ENDPOINTS,
  ENTITY_EMAIL_CAMPAIGNS,
  MODAL_EMAIL_CAMPAIGNS_MANAGE,
} from '../../config/constants'
import { storeEntities } from './resourceActions'
import { customFormUpdate } from './coreActions'

export const requestRead = options =>
  axios.get(setUrlParams(ENDPOINTS.EMAIL_CAMPAIGNS, options)).then(res => res.data)

export const crudRead = (options = {}) => dispatch => {
  dispatch({ type: actionTypes.emailCampaigns.FETCH_EMAIL_CAMPAIGNS_REQUEST })

  return requestRead(options)
    .then(response => {
      const data = response.results || []
      const count = response.count || 0

      const entityMap = {}
      data.forEach(item => {
        entityMap[item.id] = item
      })

      dispatch(storeEntities({ [ENTITY_EMAIL_CAMPAIGNS]: entityMap }))

      dispatch({
        type: actionTypes.emailCampaigns.FETCH_EMAIL_CAMPAIGNS_SUCCESS,
        payload: {
          result: data.map(item => item.id),
          count,
          page: options.page || 1,
          ordering: options.ordering || '',
        },
      })

      return data
    })
    .catch(error => {
      dispatch({
        type: actionTypes.emailCampaigns.FETCH_EMAIL_CAMPAIGNS_FAILURE,
        payload: error,
      })
    })
}

export const fetchEmailCampaigns = crudRead

export const crudDelete = id => dispatch => {
  dispatch({ type: actionTypes.emailCampaigns.DELETE_EMAIL_CAMPAIGN_REQUEST })

  return axios.delete(`${ENDPOINTS.EMAIL_CAMPAIGNS}${id}/`)
    .then(() => {
      dispatch({
        type: actionTypes.emailCampaigns.DELETE_EMAIL_CAMPAIGN_SUCCESS,
        payload: id,
      })
      toast.success(lang.successfully_deleted)
    })
    .catch(error => {
      dispatch({
        type: actionTypes.emailCampaigns.DELETE_EMAIL_CAMPAIGN_FAILURE,
        payload: error,
      })
      toast.error(lang.operation_failed)
    })
}

export const openModalForm = () => dispatch => {
  dispatch(actions.core.openModalForm({
    title: lang.new_email_campaign,
    component: MODAL_EMAIL_CAMPAIGNS_MANAGE,
    form: 'emailCampaign',
    isNew: true,
    hideSaveButton: true,
  }))
}
